<script setup lang="ts">
import { useAiLab } from '@/composables/use-ai-lab';
import History from '@/presentation/components/history/History.vue';

const { aiLabService } = useAiLab();
aiLabService.initAiLab();
</script>

<template>
    <div
        class="app-container pa-w-full pa-h-full pa-overflow-hidden pa-flex pa-flex-col pa-min-w-[1280px]"
    >
        <div class="lab-view-root pa-h-full pa-w-full pa-flex">
            <div class="lab-wrapper pa-flex-1 pa-overflow-hidden">
                <RouterView />
            </div>

            <History />
        </div>
    </div>
</template>
